import {
  handleActions,
  combineActions,
} from 'redux-actions';
import update from 'immutability-helper';
import { getUserAuthDataFromLocalStorage } from '../utils';
import UserActionCreators from '../actions/UserActionCreators';

const {
  changeUserLanguage,
  signUpRequest,
  signUpSuccess,
  signUpFailure,
  logInRequest,
  logInSuccess,
  logInFailure,
  logOutRequest,
  logOutSuccess,
  logOutFailure,
  createUserRequest,
  createUserSuccess,
  createUserFailure,
  updateUserRequest,
  updateUserSuccess,
  updateUserFailure,
  deactivateUserRequest,
  deactivateUserSuccess,
  deactivateUserFailure,
  getUserProfileRequest,
  getUserProfileSuccess,
  getUserProfileFailure,
  verifyAccessTokenRequest,
  verifyAccessTokenSuccess,
  verifyAccessTokenFailure,
  getJoinedTeamListRequest,
  getJoinedTeamListSuccess,
  getJoinedTeamListFailure,
  quickSignupRequest,
  quickSignupSuccess,
  quickSignupFailure,
  getSignupListRequest,
  getSignupListSuccess,
  getSignupListFailure,
  approveSignupRequest,
  approveSignupSuccess,
  approveSignupFailure,
  declineSignupRequest,
  declineSignupSuccess,
  declineSignupFailure,
  getCheckoutTokenRequest,
  getCheckoutTokenSuccess,
  getCheckoutTokenFailure,
  clearCheckoutToken,
} = UserActionCreators;

// Read the login status from localStorage
const { accessToken, accessTokenExpireTime, userId } = getUserAuthDataFromLocalStorage();
const isLoggedIn = !!(accessToken && parseInt(accessTokenExpireTime, 10) - Date.now() > 0);
const initialState = {
  isLoading: false,
  isLoggingOut: false,
  profile: {},
  isLoggedIn,
  accessToken: accessToken || '',
  accessTokenExpireTime: accessTokenExpireTime ? parseInt(accessTokenExpireTime, 10) : 0,
  userId: parseInt(userId, 10) || null,
  language: null,
  teamList: [],
  signupList: [],
  checkoutToken: '',
};

export default handleActions({
  [combineActions(
    getUserProfileRequest,
    createUserRequest,
    updateUserRequest,
    deactivateUserRequest,
    verifyAccessTokenRequest,
    getJoinedTeamListRequest,
    quickSignupRequest,
    approveSignupRequest,
    declineSignupRequest,
    getSignupListRequest,
    getCheckoutTokenRequest,
    signUpRequest,
    logInRequest,
  )]: state => update(state, {
    isLoading: { $set: true },
  }),
  [logOutRequest]: state => update(state, {
    isLoggingOut: { $set: true },
  }),
  [combineActions(
    getUserProfileSuccess,
    updateUserSuccess,
  )]: (state, { payload }) => update(state, {
    isLoading: { $set: false },
    profile: { $set: payload },
  }),
  [logInSuccess]: (state, { payload }) => update(state, {
    accessToken: { $set: payload.id },
    accessTokenExpireTime: { $set: payload.ttl },
    userId: { $set: payload.userId },
    isLoggedIn: { $set: true },
  }),
  [logOutSuccess]: state => update(state, {
    isLoggedIn: { $set: false },
    isLoggingOut: { $set: false },
    accessToken: { $set: '' },
    accessTokenExpireTime: { $set: '' },
    userId: { $set: null },
    profile: { $set: {} },
  }),
  [changeUserLanguage]: (state, { payload }) => update(state, {
    language: { $set: payload },
  }),
  [getJoinedTeamListSuccess]: (state, { payload }) => update(state, {
    isLoading: { $set: false },
    teamList: { $set: payload },
  }),
  [getSignupListSuccess]: (state, { payload }) => update(state, {
    isLoading: { $set: false },
    signupList: { $set: payload },
  }),
  [getCheckoutTokenSuccess]: (state, { payload }) => update(state, {
    isLoading: { $set: false },
    checkoutToken: { $set: payload },
  }),
  [combineActions(
    createUserSuccess,
    deactivateUserSuccess,
    verifyAccessTokenSuccess,
    quickSignupSuccess,
    approveSignupSuccess,
    declineSignupSuccess,
    signUpSuccess,
    getUserProfileFailure,
    createUserFailure,
    updateUserFailure,
    deactivateUserFailure,
    verifyAccessTokenFailure,
    getJoinedTeamListFailure,
    quickSignupFailure,
    declineSignupFailure,
    approveSignupFailure,
    getSignupListFailure,
    signUpFailure,
    logInFailure,
  )]: state => update(state, {
    isLoading: { $set: false },
  }),
  [logOutFailure]: state => update(state, {
    isLoggingOut: { $set: false },
  }),
  [getCheckoutTokenFailure]: state => update(state, {
    isLoading: { $set: false },
    checkoutToken: { $set: '' },
  }),
  [clearCheckoutToken]: state => update(state, {
    checkoutToken: { $set: '' },
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/user.js